import React from 'react'
import {
  CustomerDeviceMediaRecoveryAttemptAuditSnapshotV1,
  IAuditEventData,
} from '../../../api'
import { Box } from 'cs-kevlar-react'
import { DetailField } from './DetailField'
import { UnavailableDetails } from './UnavailableDetails'
import { useDetailStyles } from './useDetailStyles'
import { resolveEventData, resolveSnapshots } from './utils'
import { DetailArrayField } from './DetailArrayField'

interface CustomerDeviceMediaRecoveryDetailsProps {
  eventData: IAuditEventData | null
}

export const CustomerDeviceMediaRecoveryDetails: React.FunctionComponent<CustomerDeviceMediaRecoveryDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const snapshot = resolveEventData<CustomerDeviceMediaRecoveryAttemptAuditSnapshotV1>(
    eventData,
    nameof<CustomerDeviceMediaRecoveryAttemptAuditSnapshotV1>(),
  )

  if (!snapshot)
    return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField
          label="Device Name"
          original={snapshot.deviceName}
        />

        <DetailField
          label="Recovery Result"
          original={snapshot.recoveryResult}
        />

        {!!snapshot.mediaCounts &&
          <DetailArrayField
            label="Media"
            showDiff={false}
            updated={Object.keys(snapshot.mediaCounts).map(x => `${x}: ${snapshot.mediaCounts[x]?.toString()}`)}
            original={[]} />
        }
      </Box>
    </React.Fragment>
  )
}
